import {NgModule} from '@angular/core';
import {CommunicationConfigurationConverter} from './api/model/converter/communicationConfiguration.converter';
import {
    CommunicationConfigurationEmailConverter
} from './email/common/api/model/converter/communicationConfigurationEmail.converter';
import {CommunicationConfigurationEmailSenderModule} from "./email/sender/communicationConfigurationEmailSender.module";

@NgModule({
    providers: [
        CommunicationConfigurationConverter,
        CommunicationConfigurationEmailConverter
    ],
    imports: [
        CommunicationConfigurationEmailSenderModule
    ]
})
export class CommunicationConfigurationModule {
    constructor() {
    }
}
